import {ReactComponent as EmptySvg} from "../../assets/svg/empty.svg";
import Result from "./Result";

const Empty = ({message, title, svgFile}) => {
  return (
    <Result
      image={svgFile ? svgFile : <EmptySvg />}
      subTitle={message}
      title={title}
    />
  );
};

export default Empty;
